import { Component } from '@angular/core';
import { AfterViewInit } from '@angular/core';
import * as L from 'leaflet';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements AfterViewInit {
  private map: any;
  lat: number = 40.83433194301286;
  lng: number = 14.231501254137115;
  iconOptions : any; 

  ngAfterViewInit(): void {
    this.initMap();
  }

  private initMap(): void {
    this.map = L.map('map').setView([this.lat, this.lng], 19);

    this.iconOptions=L.icon({
      iconUrl: 'assets/img/outline_location_on_black_24dp.png',
      iconSize: [38, 45],
      //iconAnchor: [22, 94],
     // popupAnchor: [-3, -76],
   // shadowUrl: 'my-icon-shadow.png',
    shadowSize: [68, 95],
    shadowAnchor: [22, 94]
     });

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap contributors'
    }).addTo(this.map);

    L.marker([this.lat, this.lng],{icon:this.iconOptions}).addTo(this.map)
      .bindPopup('Agenzia Principe');
  }

}
